export default __webpack_public_path__ + "static/salesforce-49189c841e153a70ea36a219b0ffe045.svg";